import React, { Component } from 'react';
import {
    reduxForm, formValueSelector, SubmissionError,
} from 'redux-form';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import Cards from 'react-credit-cards';

import CardFields from './payment/card-fields';
import CheckoutStepCalculator from '../../services/checkout-step-calculator';
import ErrorMessageFormatter from '../../services/error-message-formatter';
import CreditCard from '../../services/credit-card';
import Loader from '../shared/loader';

// eslint-disable-next-line import/no-cycle
import { PAYMENT_METHODS } from '../../constants/app-chekout';

import { formatCreditCardNumber, formatExpirationDate, formatCVC } from '../../helper';

import styles from './styles/payment-form.scss';
import spreeStore from '../../store';
import actions from '../../actions';

class PaymentForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            methodSelected: this.props.order.payment_methods && this.props.order.payment_methods[0].id,
            'order[payments_attributes][0][source_attributes][verification_value]': '',
            'order[payments_attributes][0][source_attributes][expiry]': '',
            focus: '',
            'order[payments_attributes][0][source_attributes][name]': '',
            'order[payments_attributes][0][source_attributes][number]': '',
            onInputChangeHandler: this.onInputChangeHandler,
            onInputFocus: this.onInputFocus,
        };

        this.onChangePaymentMethod = this.onChangePaymentMethod.bind(this);

        document.title = this.props.intl.formatMessage({ id: 'checkout', defaultMessage: 'Checkout' });
    }

    /* Render this step only if order is present and in a valid checkout state. */
    componentWillMount() {
        const { order } = this.props;

        if (!CheckoutStepCalculator.isStepEditable(order.checkout_steps, 'payment', order.state)) {
            this.props.handleCheckoutStepNotEditable(order, this.props.placedOrder);
        }

        if (!order.id) {
            this.props.redirectToCart();
        }
    }

    componentDidMount() {
        if (!this.hasPaymentMethod()) {
            this.props.handleCreditCardChange(); // disable payment with card button if the page was refreshed
        }
        this.props.setCurrentCheckoutStep();
        spreeStore.dispatch(actions.hideLoader());
    }

    componentDidUpdate(prevProps) {
        if (this.props.locale !== prevProps.locale) {
            document.title = this.props.intl.formatMessage({ id: 'checkout', defaultMessage: 'Checkout' });
        }
    }

    onChangePaymentMethod(paymentMethodId) {
        if (paymentMethodId === this.state.methodSelected) {
            this.setState({
                methodSelected: null,
            });
        } else {
            this.setState({
                methodSelected: paymentMethodId,
            });
        }
    }

    onInputChangeHandler = (e) => {
        const { name, value } = e.target;
        let newValue = value;
        switch (name) {
        case 'order[payments_attributes][0][source_attributes][number]':
            newValue = formatCreditCardNumber(value);
            break;
        case 'order[payments_attributes][0][source_attributes][expiry]':
            newValue = formatExpirationDate(value);
            break;
        case 'order[payments_attributes][0][source_attributes][verification_value]':
            newValue = formatCVC(value);
            break;
        default:
            break;
        }
        this.setState({
            [name]: newValue,
        });
    }

    onInputFocus = (e) => {
        let focusTarget = '';
        switch (e.target.name) {
        case 'order[payments_attributes][0][source_attributes][name]':
            focusTarget = 'name';
            break;
        case 'order[payments_attributes][0][source_attributes][number]':
            focusTarget = 'number';
            break;
        case 'order[payments_attributes][0][source_attributes][expiry]':
            focusTarget = 'expiry';
            break;
        default:
            focusTarget = 'cvc';
            break;
        }
        this.setState({
            focus: focusTarget,
        });
    }

    hasPaymentMethod() {
        return !!this.state['order[payments_attributes][0][source_attributes][name]']
        && !!this.state['order[payments_attributes][0][source_attributes][number]'];
    }

    handlePaymentFormSubmit(formData) {
        window.scrollTo(0, 0);

        let data = {};

        if (formData && formData.order) {
            // eslint-disable-next-line camelcase
            const { payments_attributes } = formData.order;
            let [expDateMonth, expDateYear] = payments_attributes[0].source_attributes.expiry.split('/');

            if (expDateYear === undefined) {
                expDateYear = null;

                if (expDateMonth === undefined) {
                    expDateMonth = null;
                } else {
                    expDateYear = expDateMonth.substring(2);
                    expDateMonth = expDateMonth.substring(0, 2);
                }
            }

            data = {
                order: {

                    payments_attributes: [
                        {
                            payment_method_id: this.state.methodSelected,
                        },
                    ],
                },
                payment_source: {
                    [this.state.methodSelected]: {
                        number: payments_attributes[0].source_attributes.number,
                        month: expDateMonth,
                        year: expDateYear,
                        verification_value: payments_attributes[0].source_attributes.verification_value,
                        name: payments_attributes[0].source_attributes.name,
                    },
                },
            };
        }

        return this.props.handlePaymentFormSubmit(data, this.props.order, this.props.locale.currentLocale).then(
            this.props.handleSaveCreditCardSuccess,
            (error) => {
                console.log(error);
                const sanitizedErrors = this.formattedErrorMessages(error.response.body.errors);
                this.props.showFormErrors(sanitizedErrors);

                throw new SubmissionError({ order: sanitizedErrors });
            },
        );
    }

    // eslint-disable-next-line class-methods-use-this
    formattedErrorMessages(errors) {
        const formErrors = errors['payments.Credit Card'];
        return ErrorMessageFormatter.formatFormSubmissionErrors(formErrors);
    }

    buildReadOnlyCreditCardData() {
        return (
            <div style={{ marginLeft: '15px' }}>
                <div style={{ display: 'flex' }}>
                    <div>
                        <img
                            style={{
                                width: '50px', height: '50px', marginTop: '12px', marginRight: '15px',
                            }}
                            src={`/pay-types/${CreditCard.ccType(this.state['order[payments_attributes][0][source_attributes][number]'])}-logo.png`}
                            alt="CC logo"
                        />
                    </div>
                    <div>
                        <div className={styles.cardData}>
                            <FormattedMessage
                                id="payment-form-cc-name"
                                values={{ name: this.state['order[payments_attributes][0][source_attributes][name]'] }}
                                defaultMessage=""
                            />
                            <FormattedMessage
                                id="payment-form-cc-number"
                                values={{ number: CreditCard.mask(this.state['order[payments_attributes][0][source_attributes][number]']) }}
                                defaultMessage=""
                            />
                        </div>
                    </div>
                </div>
                <button type="button" className="button--outlined" onClick={this.props.handleCreditCardChange}>
                    <FormattedMessage
                        id="payment-form-edit"
                        defaultMessage="Edit"
                    />
                </button>
            </div>
        );
    }

    render() {
        const {
            handleSubmit, valid, submitting, order,
        } = this.props;
        const paymentMethods = (order && order.payment_methods) || [];

        const paymentMethodMarkup = paymentMethods.map((paymentMethod, idx) => (
            paymentMethod.attributes.name === PAYMENT_METHODS.credit_card && (
                <div className="credit-card__container" key={idx}>
                    <Cards
                        cvc={this.state['order[payments_attributes][0][source_attributes][verification_value]']}
                        expiry={this.state['order[payments_attributes][0][source_attributes][expiry]']}
                        focused={this.state.focus}
                        name={this.state['order[payments_attributes][0][source_attributes][name]']}
                        number={this.state['order[payments_attributes][0][source_attributes][number]']}
                        callback={(type) => {
                            this.setState({
                                maxLength: type.maxLength,
                            });
                        }}
                    />
                </div>
            )));

        return (
            <div>
                {submitting && (
                    <div className="checkout-loading-container">
                        <FormattedMessage id="saving-payment" defaultMessage="Saving payment" />
                        <Loader displayLoader size={36} />
                    </div>
                )}
                {!submitting && this.props.displayLoader && (
                    <div className="checkout-loading-container">
                        <FormattedMessage id="please-wait" defaultMessage="please wait" />
                        <Loader displayLoader size={36} />
                    </div>
                )}
                <form
                    onSubmit={handleSubmit(this.handlePaymentFormSubmit.bind(this))}
                    style={{ display: submitting || (!submitting && this.props.displayLoader) ? 'none' : 'inherit' }}
                >
                    <div className="checkout-payment-options-block">
                        {/* {paymentMethods.length > 1 && ( */}
                        {/*    <div className="checkout-payment-paymeth-lab"> */}
                        {/*        <FormattedMessage id="payment-methods" defaultMessage="Payment methods" /> */}
                        {/*    </div> */}
                        {/* )} */}
                        { this.props.displayPreview && paymentMethodMarkup }
                    </div>

                    {this.props.isReadOnly && this.hasPaymentMethod()
                        ? this.buildReadOnlyCreditCardData()
                        : <CardFields {...this.state} />}

                    <div className="checkout-payment-button-block">
                        {this.props.hasBackButton
                            && (
                                <button
                                    type="button"
                                    className="button--outlined"
                                    style={{ margin: 30 }}
                                >
                                    <FormattedMessage id="back" defaultMessage="Back" />
                                </button>
                            )}
                        <div className={styles.paymentFormAction}>
                            {!this.props.isReadOnly && (
                                <button type="submit" style={{ width: 'auto' }} className={`button--outlined ${submitting && 'button-disabled'}`} disabled={!valid || submitting}>
                                    <span className="checkout-button-text__desktop"><FormattedMessage id="savePaymentMethod" defaultMessage="Save Payment Details" /></span>
                                    <span className="checkout-button-text__mobile"><FormattedMessage id="savePaymentMethod" defaultMessage="Pay" /></span>
                                </button>
                            )}
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

PaymentForm = reduxForm({
    form: 'paymentForm',
})(PaymentForm);

const selector = formValueSelector('paymentForm');
PaymentForm = connect((state) => {
    const useCard = selector(state, 'order[payments_attributes][0][payment_method_id]');
    return {
        useCard,
    };
})(PaymentForm);

export default injectIntl(PaymentForm);



/** WEBPACK FOOTER **
 ** ./src/components/checkout-steps/payment-form.jsx
 **/